import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SELLER_TYPE } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'ui-gif-loader',
  templateUrl: './ui-gif-loader.component.html',
  styleUrls: ['./ui-gif-loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UiGifLoaderComponent {
  @Input() text: string;
  @Input() useDefaultColor = true;
  @Input() sellerType: SELLER_TYPE;

  SELLER_TYPE = SELLER_TYPE;
}
